/**
 * Creates a new Google Maps session using the provided API key and stores it in local storage
 * @param apiKey The Google Maps API key
 * @returns The Google Maps session token
 */
export async function createGoogleMapSession(apiKey: string): Promise<string> {
    const response = await fetch(`https://tile.googleapis.com/v1/createSession?key=${apiKey}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mapType: "satellite", language: "en-GB", region: "GB" }),
    });
    const data = await response.json();

    if (!response.ok) {
        throw new Error(`Error creating Google Maps session: ${data.error.message}`);
    }

    return data.session;
}
